module.exports = __webpack_public_path__ + "assets/img/icon10.3a82d4a3.svg";